<template>
  <div class='EnbModel03Themes'>
    <input-select
    @update:modelValue="newValue => UpdateTema(newValue)"
    :key="key"
    :data="temas"
    :text="'Selecione o tema'"
    :label="{ textAlign: 'left', marginTop: '1%', marginLeft: '5px', fontSize: '16px' }"
    :input="{ width: '100%', padding: '1%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    :value="value"
    valueVazio
    />
    <div class="load" v-if="load">
      <vue-spinner size="45"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputSelect from '../Produtos/Register/InputSelect'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'EnbModel03Themes',
  components: { InputSelect, VueSpinner },
  data () {
    return {
      value: '',
      load: false,
      timer: null,
      temas: [
        {
          name: 'Tema 01',
          updatecomp: [
            { comp: 'componentModel03Nave', prop: 'name', value: 'EnbNave0301' },
            { comp: 'componentModel03Prod', prop: 'name', value: 'EnbProduto' }
          ]
        },
        {
          name: 'Tema 02',
          updatecomp: [
            { comp: 'componentModel03Nave', prop: 'name', value: 'EnbNave0302' },
            { comp: 'componentModel03Prod', prop: 'name', value: 'EnbProduto02' }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  },
  methods: {
    ...mapActions(['UpdatePrefComp']),
    UpdateTema(data) {
      //spinner visível por 3s, já que a troca é instantânea
      this.load = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.load = false, 3000)
      for(let key in this.temas) {
        if(this.temas[key].name === data) {
          for(let k in this.temas[key].updatecomp) {
            this.UpdatePrefComp(this.temas[key].updatecomp[k])
          }
        }
      }
    }
  },
  created () {
    if(!this.Prefes.componentModel03Nave) {
      this.value = 'Tema 01'
      return
    }
    for(let key in this.temas) {
      for(let k in this.temas[key].updatecomp) {
        if(this.temas[key].updatecomp[k].value === this.Prefes.componentModel03Nave.name) {
          this.value = this.temas[key].name
        }
      }
    }
  },
  beforeUnmount () {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.EnbModel03Themes {
  width: 100%;
  height: 100%;
  position: relative;
}

/* sobrepõe a tela, com o spinner no centro */
.load {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.6);
}
</style>
